import { deleteMac } from 'features/tenant/api/macs';
import { getTenantsInUnit } from 'shared/api/units';
import {
  createGroupDpsk,
  deleteGroupDpsk,
  getGroupDpsk,
  getSmartzone,
} from 'shared/api/wireless';
import { checkGroupDpsk } from 'shared/utils/formatters';

// Deletes a list of devices for tenant.
// Returns number of records removed.
export async function deleteDevices(request, devices) {
  let numDeleted = 0;

  const macDeletePromises = [];
  devices.forEach((device) => {
    macDeletePromises.push(request(deleteMac(device.id)));
  });
  const macDeleteResult = await Promise.all(macDeletePromises);

  numDeleted += macDeleteResult.filter((r) => r).length;
  return numDeleted;
}

// Recreates a unit's group dpsk when the unit doesn't have tenants and the key is old.
// Should be called before tenants are moved in, and after tenants move out.
// Returns false if any error happens.
export async function cycleGroupDpsk(request, building, unit) {
  if (!building || !building.dot1x || !building.dot1x.smartzone_id || !unit.vlan) {
    return true;
  }

  const szResult = await request(getSmartzone(building.dot1x.smartzone_id));
  if (!szResult) return false;

  const [
    groupDpskResult,
    tenantsResult,
  ] = await Promise.all([
    request(getGroupDpsk(unit.id)),
    request(getTenantsInUnit(unit.id)),
  ]);
  if (!groupDpskResult || !tenantsResult) {
    return false;
  }

  const noTenantsInUnit = tenantsResult.length === 0;
  let hasGroupDpsk = !!groupDpskResult.data;
  if (hasGroupDpsk) {
    const groupDpsk = groupDpskResult.data;
    const { status } = checkGroupDpsk(groupDpsk);
    if (noTenantsInUnit && status !== 'NEW') {
      // The unit doesn't have any tenants and the group dpsk is older than 6 months.
      // Delete the dpsk, and set hasGroupDpsk to false, which will cause it to be recreated.
      const deleteResult = await request(deleteGroupDpsk(groupDpsk.unit_id));
      if (!deleteResult) return false;
      hasGroupDpsk = false;
    }
  }

  if (!hasGroupDpsk) {
    // If the unit doesn't have a group dpsk, create it.
    const createResult = await request(createGroupDpsk(unit.id));
    return !!createResult;
  }
  return true;
}
